<div *transloco="let t; read: 'building'">
  <sibat-typology-indicator [color]="building.typology?.color"></sibat-typology-indicator>
  @if (building.addresses?.length > 0) {
  <span>{{ building.addresses[0] | breakAddress }}</span>
  } @else {
  <span>{{ t('addressNotAvailable') }}</span>
  }
</div>
